import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SessionsTab } from "../psychologist/tabs";
import { usePsychologistData } from "../../hooks/usePsychologistData";
import { PatientDetailModal } from "../psychologist/tabs/patients/components/PatientDetailModal";
import type { Patient } from "../psychologist/tabs/patients/components/PatientTable";

export const SessionsPage = () => {
  const navigate = useNavigate();
  const psychologist = usePsychologistData();
  const [detailPatient, setDetailPatient] = useState<Patient | null>(null);

  return (
    <>
      <SessionsTab
        psychologist={psychologist}
        onPatientClick={(patientId, processId, patientName, therapyType) => {
          setDetailPatient({
            id: patientId,
            processId: processId || patientId,
            name: patientName || "",
            service: therapyType,
            totalSessions: 0,
          });
        }}
        onSchedule={(processId) => navigate(processId ? `/calendar?process=${encodeURIComponent(processId)}` : '/calendar')}
      />
      {detailPatient && (
        <PatientDetailModal
          patient={detailPatient}
          onClose={() => setDetailPatient(null)}
        />
      )}
    </>
  );
};
